import {useIntl} from 'react-intl'
import DateFormatter from '../../../DateFormatter'

function HR({hrDetails}) {
  const {
    manager_reviewed_status = null,
    hr_reviewed_status = null,
    hr_reviewed_amount = 0,
    hr_review_comments = '',
    hr_reviewed_timestamp = '',
    currency_code = null,
    itemStatus = null,
  } = hrDetails

  const intl = useIntl()

  const getHrView = (itemStatus, hrStatus) => {
    if (itemStatus === 'HR Pending') {
      // if (ManagerStatus === 'Approved' && hrStatus === null) {
      return null
    } else if (hrStatus === 'Approved' || hrStatus === 'Rejected') {
      return (
        <>
          <p className='m-0 text-muted default-cursor'>
            {hr_reviewed_timestamp ? (
              <>
                {hr_reviewed_timestamp.length >= 10 &&
                  DateFormatter(hr_reviewed_timestamp.slice(0, 10))}{' '}
                {hr_reviewed_timestamp.length >= 19 && hr_reviewed_timestamp.slice(10, 19)}
              </>
            ) : (
              '-'
            )}
          </p>
          <p className='m-0 text-muted default-cursor'>{`${
            hr_review_comments ? hr_review_comments : '-'
          }`}</p>
        </>
      )
    } else {
      return null
    }
  }

  const getStatusMsg = (itemStatus, hrStatus) => {
    if (itemStatus === 'Manager Pending') {
      return 'LABLE.AWAITING_MANAGERS_ACTION'
    } else if (
      (itemStatus === 'Rejected' && hrStatus === null) ||
      (hrStatus === null && itemStatus === 'Revoked')
    ) {
      return 'LABLE.NO_ACTION'
    } else if (itemStatus === 'HR Pending') {
      return 'LABEL.PENDING'
    } else if (itemStatus !== 'HR Pending' && hrStatus) {
      if (hrStatus === 'Approved') {
        return 'LABEL.APPROVED'
      } else {
        return 'LABEL.REJECTED'
      }
    } else {
      if (hrStatus === 'Approved') {
        return 'LABEL.APPROVED'
      } else {
        return 'LABEL.REJECTED'
      }
    }
  }

  const getStatusColor = (itemStatus, hrStatus) => {
    if (itemStatus === 'Manager Pending') {
      return 'muted'
    } else if (
      (itemStatus === 'Rejected' && hrStatus === null) ||
      (hrStatus === null && itemStatus === 'Revoked')
    ) {
      return 'secondary'
    } else if (itemStatus === 'HR Pending') {
      return 'muted'
    } else if (itemStatus !== 'HR Pending' && hrStatus === 'Approved') {
      return 'success'
    } else {
      return 'danger'
    }
  }

  const getApprovedAmount = () => {
    if (hr_reviewed_status === 'Approved') {
      return ` (${currency_code}: ${hr_reviewed_amount})`
    }
  }

  return (
    <div className='timeline-item'>
      <div className='timeline-line w-20px'></div>

      <div className='timeline-icon symbol symbol-circle symbol-20px'>
        <div
          className={`symbol-label bg-${getStatusColor(
            itemStatus,
            hr_reviewed_status
          )} icon-dotted-border text-${getStatusColor(itemStatus, hr_reviewed_status)}`}
        ></div>
      </div>

      <div className='timeline-content mb-12 mt-n1'>
        <div className='d-flex justify-content-between mt-1'>
          <p
            className={`mb-0 fw-bold text-${getStatusColor(
              itemStatus,
              hr_reviewed_status
            )} default-cursor`}
          >
            {/* {getStatusMsg(itemStatus, hr_reviewed_status)} */}
            {intl.formatMessage({id: getStatusMsg(itemStatus, hr_reviewed_status)})}
            <span className='text-muted fw-normal'>{getApprovedAmount()}</span>
          </p>
          <div className=''>
            <p className='designation-btn bg-secondary fs-7 m-auto default-cursor'>
              {intl.formatMessage({id: 'LABEL.HR'})}
            </p>
          </div>
        </div>
        {getHrView(itemStatus, hr_reviewed_status)}
      </div>
    </div>
  )
}

export default HR
